module.exports = __webpack_public_path__ + "static/media/mileageIcon.755d369e.svg";